import { render, staticRenderFns } from "./BoingContent.vue?vue&type=template&id=47af1f15&scoped=true&"
import script from "./BoingContent.vue?vue&type=script&lang=js&"
export * from "./BoingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af1f15",
  null
  
)

export default component.exports